document.addEventListener("DOMContentLoaded", function () {
  const settings = document.getElementById("page-settings");
  if (!settings) return;

  const bgColor = settings.getAttribute("data-bg-color");
  const textColor = settings.getAttribute("data-text-color");
  const logoColor = settings.getAttribute("data-logo-color");

  // Apply background and text color
  document.body.style.backgroundColor = bgColor;
  document.body.style.color = textColor;

  // Update burger menu bar color
  document.querySelectorAll(".header .burger-menu .burger-bar").forEach(bar => {
    bar.style.backgroundColor = textColor;
  });

  // Apply filter to logo
  const logo = document.querySelector(".logo");
  if (logo) {
    logo.style.filter = (logoColor === "dark") 
      ? "invert(1) sepia(0%) saturate(100%) hue-rotate(0deg) brightness(100%) contrast(100%)"
      : "invert(0) sepia(0%) saturate(100%) hue-rotate(0deg) brightness(100%) contrast(100%)";
  }
});
